import { render, staticRenderFns } from "./show.gigs.page.vue?vue&type=template&id=03ffb612&scoped=true&"
import script from "./show.gigs.page.vue?vue&type=script&lang=js&"
export * from "./show.gigs.page.vue?vue&type=script&lang=js&"
import style0 from "./show.gigs.page.vue?vue&type=style&index=0&id=03ffb612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffb612",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSubheader})
